export default __webpack_public_path__ + "static/media/card-blog3.46056f06.png";